import { isAnalyticalCookieSet } from '@wkda/funnel-utils';
export function createApi(httpClient) {
  return {
    cjTracking
  };
  function cjTracking(params) {
    const isAnalyticalCookieAllowed = isAnalyticalCookieSet();
    return isAnalyticalCookieAllowed ? httpClient.post('/tracking', params).then(r => {
      return r.data;
    }) : Promise.resolve({
      createdAt: '',
      event: '',
      uuid: ''
    });
  }
}